import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { ConfigService, DigihavenEnvironmentConfig } from '@digihaven/shared';

import { UserTokens } from '@common/entities/user-tokens.entity';

import { ApplicationState } from 'state';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private userTokens$: Observable<UserTokens>;

    constructor(
        public store: Store<ApplicationState>,
        private readonly config: ConfigService<DigihavenEnvironmentConfig>
    ) {
        this.userTokens$ = this.store.select<UserTokens>(state => state.token.userTokens);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.userTokens$.pipe(
            take(1),
            switchMap((token: UserTokens) => {
                if (request.url.startsWith(this.config.config.apiUrl) || request.url.endsWith('/download')) {
                    const authenticatedRequest: HttpRequest<any> = this.appendAuthorizationToken(request, token);
                    return next.handle(authenticatedRequest);
                }

                return next.handle(request);
            })
        );
    }

    private appendAuthorizationToken(request: HttpRequest<any>, token: UserTokens): HttpRequest<any> {
        let authenticatedRequest: HttpRequest<any>;

        let headers: HttpHeaders = request.headers || new HttpHeaders();
        if (token && token.access_token && token.token_type) {
            headers = headers.append('Authorization', `bearer ${token.access_token}`);
            authenticatedRequest = request.clone({ headers });
        } else {
            authenticatedRequest = request;
        }

        return authenticatedRequest;
    }
}
